<script setup>
import { ref,inject,onMounted,provide  } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios';
import { useMemberStore } from '../../stores';
const userStore = useMemberStore();

const size = ref('default')
const labelPosition = ref('right')
const headers = ref({
	'Authorization': `${userStore.profile?.token}`,
})
const miniUserDatas = ref([])
onMounted(async()=>{
	const res = await axios.post('/coupon/yhq/queryMiniUserList', {
	}, {
	  headers: {
	    'Content-Type': 'application/json',
		Authorization: `${userStore.profile?.token}`,
	  }
	});
	if(res.data.status===0){
		miniUserDatas.value = res.data.data.map(item=>{
			return {
				label:item.id+"/"+item.name+"/"+item.mobile,
				value:item.id,
			}
		})
	}
})
const sizeForm = ref({
	applyUser:'',
	zfje:0,
	ymdd:'',
	zfjl:''
});
const onSubmit=async()=> {
	let isNull = false;
	Object.keys(sizeForm.value).forEach(key=>{
		if(sizeForm.value[key]===''){
			isNull = true;
		}
	})
	if(!isNull){
		const response = await axios.post('/integral/info/apply', {
		  ...sizeForm.value
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage.success('提交成功!')
			sizeForm.value = {}
		}
	}else{
		ElMessage.error('所有信息不可为空!')
	}
}
const handleYmddSuccess= (
  response,
  uploadFile
) => {
  if(response.status===0){
  	sizeForm.value.ymdd = response.imgUrl
  }
}
const handleZfjlSuccess= (
  response,
  uploadFile
) => {
  if(response.status===0){
  	sizeForm.value.zfjl = response.imgUrl
  }
}

const beforeAvatarUpload = (rawFile) => {
  if (rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/png') {
    ElMessage.error('Avatar picture must be JPG/PNG format!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 20) {
    ElMessage.error('Avatar picture size can not exceed 20MB!')
    return false
  }
  return true
}

</script>
<template>
	<el-form
	    ref="form"
	    :model="sizeForm"
	    label-width="auto"
	    :label-position="labelPosition"
	    :size="size"
	>
		<div style="display: flex;">
			<el-form-item label="积分发放对象" style="width: 96%;">
			  <el-select
			  	v-model="sizeForm.applyUser"
			  	filterable
			  	placeholder="选择人员"
			  	style="width: 440px"
			  	:clearable="true"
			  	collapse-tags
			  >
			  	<el-option
			  	  v-for="item in miniUserDatas"
			  	  :key="item.value"
			  	  :label="item.label"
			  	  :value="item.value"
			  	/>
			  </el-select>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="支付金额" style="width: 96%;">
			  <el-input-number class="w-50 m-2" v-model="sizeForm.zfje" :step="1"/>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="医美订单" style="width: 96%;">
			  <el-upload
			    class="avatar-uploader"
			    action="https://server.walkertour.cn/integral/info/uploadFile"
			    :headers="headers"
				:data="{billid:userStore.profile?.userid}"
			    :show-file-list="false"
			    :on-success="handleYmddSuccess"
			    :before-upload="beforeAvatarUpload"
			  	crossorigin="anonymous"
			  >
			    <img v-if="sizeForm.ymdd" :src="sizeForm.ymdd" class="avatar" />
			    <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
			  </el-upload>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="支付记录" style="width: 96%;">
			  <el-upload
			    class="avatar-uploader"
			    action="https://server.walkertour.cn/integral/info/uploadFile"
			    :headers="headers"
				:data="{billid:userStore.profile?.userid}"
			    :show-file-list="false"
			    :on-success="handleZfjlSuccess"
			    :before-upload="beforeAvatarUpload"
			  	crossorigin="anonymous"
			  >
			    <img v-if="sizeForm.zfjl" :src="sizeForm.zfjl" class="avatar" />
			    <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
			  </el-upload>
			</el-form-item>
		</div>
		<div style="display: flex;justify-content: center;">
			<el-form-item>
		      <el-button type="primary" @click="onSubmit">提交</el-button>
		    </el-form-item>
		</div>
	</el-form>
</template>

<style scoped>
	.avatar-uploader .avatar {
	  width: 90px;
	  height: 90px;
	  display: block;
	}
	.avatar-uploader .el-upload {
	  border: 1px dashed var(--el-border-color);
	  border-radius: 6px;
	  cursor: pointer;
	  position: relative;
	  overflow: hidden;
	  transition: var(--el-transition-duration-fast);
	}
	
	.avatar-uploader .el-upload:hover {
	  border-color: var(--el-color-primary);
	}
	
	.el-icon.avatar-uploader-icon {
	  font-size: 28px;
	  color: #8c939d;
	  width: 90px;
	  height: 90px;
	  text-align: center;
	}
</style>